import { MaterialSymbols_600SemiBold } from '@expo-google-fonts/material-symbols/600SemiBold';

import type { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_600SemiBold',
  font: MaterialSymbols_600SemiBold,
};
export default weight;
